import React, { useState } from "react";
import CTABanner from "../components/CTABanner";
import Testimonials from "../components/Testimonials";
import BrochureModal from "../components/BrochureModal";
import WelcomeBack from "../components/WelcomeBack";
import {
  HeroSection,
  OutcomesSection,
  ServicesSection,
  Ekselens360Section,
  Enterprise360MomentSection,
  PriorityOffersSection,
  WhyEkselensSection,
  IndustriesSection,
} from "./home/sections";

const Home = () => {
  const [brochureOffer, setBrochureOffer] = useState(null);

  return (
    <>
      <WelcomeBack />
      <HeroSection />
      <OutcomesSection />
      <ServicesSection />
      <Ekselens360Section />
      <Enterprise360MomentSection />
      <PriorityOffersSection onBrochure={setBrochureOffer} />
      <WhyEkselensSection />
      <Testimonials variant="dark" heading="What clients say" />
      <CTABanner />
      <IndustriesSection />

      <BrochureModal
        open={!!brochureOffer}
        offer={brochureOffer}
        onClose={() => setBrochureOffer(null)}
      />
    </>
  );
};

export default Home;
